import { CheckCircle2, Circle, Clock3, Undo2, XCircle } from 'lucide-react'

export type MovementKind = 'income' | 'expense' | 'transfer'
export function movementState(status:string, date?:string|null) {
  const normalized=String(status||'').trim().toUpperCase()
  if(['PAGO','RECEBIDO','REALIZADO','REALIZADA'].includes(normalized))return 'realized'
  if(['ESTORNADO','ESTORNADA'].includes(normalized))return 'reversed'
  if(['CANCELADO','CANCELADA'].includes(normalized))return 'cancelled'
  if(['PENDENTE','PREVISTO','PREVISTA'].includes(normalized)) {
    const now=new Date(), today=`${now.getFullYear()}-${String(now.getMonth()+1).padStart(2,'0')}-${String(now.getDate()).padStart(2,'0')}`
    return date && /^\d{4}-\d{2}-\d{2}/.test(date) && date.slice(0,10)<today?'overdue':'forecast'
  }
  return 'other'
}
const names={income:'Entrada',expense:'Saída',transfer:'Transferência'}
export default function MovementStatus({kind,status,date}:{kind:MovementKind;status:string;date?:string|null}) {
  const state=movementState(status,date)
  const Icon=state==='realized'?CheckCircle2:state==='overdue'?Clock3:state==='reversed'?Undo2:state==='cancelled'?XCircle:Circle
  const label={realized:'Realizado',forecast:'Previsto',overdue:'Previsto · vencido',reversed:'Estornado',cancelled:'Cancelado',other:status||'Sem status'}[state]
  return <span className="movement-status" data-state={state} aria-label={`${names[kind]}: ${label}`}><Icon size={12} aria-hidden="true"/><span>{label}</span></span>
}
